<template><div><h1>umd 组件构建及使用</h1>
<div class="tip">
<p>从<code>2.0</code>开始，推荐使用<code>webpack</code>来调用组件，因此不再在<code>repo</code>中保存<code>umd</code>文件，但提供了生成命令。</p>
<p>请更新 <code>NodeJS</code> 到版本 <code>7.6.0</code>及以上。</p>
<p>例子可查看：<a href="https://github.com/airyland/vux/tree/v2/docs/examples">https://github.com/airyland/vux/tree/v2/docs/examples</a></p>
</div>
<div class="danger">
<p>强烈建议使用 <code>webpack</code> 的方式开发，在 3.0 之后可能不再提供支持。</p>
</div>
<h2>生成命令</h2>
<pre class="hljs"><code>git <span class="hljs-built_in">clone</span> https://github.com/airyland/vux.git --depth=1 // or just update: git pull
<span class="hljs-built_in">cd</span> vux
npm install
npm run build-components
</code></pre>
<p>默认生成的语言是<code>zh-CN</code>，模块命名空间为<code>vux</code>，如<code>vuxGroup</code>，<code>vuxCell</code>，你可以在命令行中配置。</p>
<pre class="hljs"><code>npm run build-components -- --locale='en' --namespace='X'
</code></pre>
<h2>目录结构</h2>
<p>生成的文件夹结构如：</p>
<div class="tip">
<p>出于目录结构一致性考虑，即使是子组件也是一个文件夹，并且会有一个空的<code>index.min.css</code>样式文件。</p>
</div>
<pre class="hljs"><code>|- dist/
  |- vux.min.js ------------ 所有组件打包，仅用于测试，不推荐在生产环境使用
  |- vux.min.css ----------- 所有组件样式打包，同样仅用于测试
  |- components
      |- actionsheet
        |- index.min.js -------- 组件js代码
        |- index.min.css ------- 组件css代码
</code></pre>
<div class="tip">
<p>vux.min.js 包括了所有的组件、插件及默认地址库，都挂载在全局变量vux上。当然为了使用方便同样直接挂载到了<code>window</code>上。</p>
<p>组件调用举例: <code>vuxCell</code></p>
<p>插件调用举例：<code>vuxAlertPlugin</code></p>
<p>默认地址库调用：<code>vuxChinaAddressData</code></p>
</div>
<h2>组件使用</h2>
<pre class="hljs"><code><span class="hljs-meta">&lt;!DOCTYPE html&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">html</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"en"</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">head</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">meta</span> <span class="hljs-attr">charset</span>=<span class="hljs-string">"UTF-8"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">title</span>&gt;</span>scripts<span class="hljs-tag">&lt;/<span class="hljs-name">title</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">link</span> <span class="hljs-attr">rel</span>=<span class="hljs-string">"stylesheet"</span> <span class="hljs-attr">href</span>=<span class="hljs-string">"../dist/vux.min.css"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">script</span> <span class="hljs-attr">src</span>=<span class="hljs-string">"https://unpkg.com/vue/dist/vue.js"</span>&gt;</span><span class="undefined"></span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">head</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">body</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">id</span>=<span class="hljs-string">"demo"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Vue"</span> <span class="hljs-attr">:value</span>=<span class="hljs-string">"how"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">cell</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>

  <span class="hljs-tag">&lt;<span class="hljs-name">script</span> <span class="hljs-attr">src</span>=<span class="hljs-string">"../dist/components/group/index.js"</span>&gt;</span><span class="undefined"></span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">script</span> <span class="hljs-attr">src</span>=<span class="hljs-string">"../dist/components/cell/index.js"</span>&gt;</span><span class="undefined"></span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

  <span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="actionscript">
  Vue.component(<span class="hljs-string">'group'</span>, vuxGroup)
  Vue.component(<span class="hljs-string">'cell'</span>, vuxCell)
  <span class="hljs-keyword">new</span> Vue({
    el: <span class="hljs-string">'#demo'</span>,
    data: {
      how: <span class="hljs-string">'Cool'</span>
    }
  })
  </span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">body</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">html</span>&gt;</span>
</code></pre>
<h2>插件使用</h2>
<pre class="hljs"><code><span class="hljs-meta">&lt;!DOCTYPE html&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">html</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"en"</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">head</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">meta</span> <span class="hljs-attr">charset</span>=<span class="hljs-string">"UTF-8"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">meta</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"viewport"</span> <span class="hljs-attr">content</span>=<span class="hljs-string">"width=device-width,initial-scale=1,user-scalable=0"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">title</span>&gt;</span>scripts<span class="hljs-tag">&lt;/<span class="hljs-name">title</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">link</span> <span class="hljs-attr">rel</span>=<span class="hljs-string">"stylesheet"</span> <span class="hljs-attr">href</span>=<span class="hljs-string">"../../dist/styles/reset.css"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">link</span> <span class="hljs-attr">rel</span>=<span class="hljs-string">"stylesheet"</span> <span class="hljs-attr">href</span>=<span class="hljs-string">"../../dist/plugins/alert/index.min.css"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">script</span> <span class="hljs-attr">src</span>=<span class="hljs-string">"https://unpkg.com/vue/dist/vue.js"</span>&gt;</span><span class="undefined"></span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">head</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">body</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">id</span>=<span class="hljs-string">"demo"</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>

  <span class="hljs-tag">&lt;<span class="hljs-name">script</span> <span class="hljs-attr">src</span>=<span class="hljs-string">"../../dist/plugins/alert/index.min.js"</span>&gt;</span><span class="undefined"></span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

  <span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="actionscript">
  Vue.use(vuxAlertPlugin)

  <span class="hljs-keyword">new</span> Vue({
    el: <span class="hljs-string">'#demo'</span>,
    data: {
      how: <span class="hljs-string">'Cool'</span>
    },
    mounted () {
      <span class="hljs-keyword">this</span>.$vux.alert.show(<span class="hljs-string">'hello'</span>)
    }
  })
  </span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">body</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">html</span>&gt;</span>
</code></pre>
<h2>生成css工具样式</h2>
<p>包括<code>1px</code>解决方案，构建文件位于<code>dist/styles/*.css</code>,构建方式：</p>
<pre class="hljs"><code>npm run build-styles
</code></pre>
<div class="tip">
<p>为了使用方便，可以使用<code>npm run xbuild</code>来执行<code>build-components</code> 及 <code>build-styles</code></p>
</div>
</div></template><script>
export default {
  head: {"title":"umd 组件构建及使用 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// umd-171.vue?24642f9e